<template>
  <div class="row position-relative align-items-center follow-btn-cta">
    <div class="col-auto text-center">
      <FollowBtn
        :model="account"
        follow-class="btn-primary"
        hover-class="btn-secondary"
        unfollow-class="unfolow-btn"
      />
    </div>
    <div
      class="additional-actions-wrapper col-auto position-absolute d-flex align-items-center justify-content-end"
    >
      <Icon
        v-if="canJoin(account) && statusOfRequest !== 'pending'"
        class="cursor-pointer mx-3"
        name="join"
        width="24"
        @click.native="joinAction"
      />
      <span v-if="canJoin(account) && statusOfRequest === 'pending'"
        >Requested
      </span>
      <span
        class="playhera-icon mx-3 cursor-pointer"
        @click.prevent="
          $event =>
            openSharingMenu({
              event: $event,
              type: account._type,
              text: `${$filters.displayName(account)} ${$t(
                '_web_' + account._type,
                account._type
              )} on `,
              id: account._id,
              vanityId: account.vanityId,
            })
        "
      >
        <Icon name="share" />
      </span>
      <button
        type="button"
        class="btn-transparent p-2 cursor-pointer text-secondary"
        @click="setActionPopover($event)"
      >
        <Icon name="dots" />
      </button>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import { join } from '@/mixins/accountActions/clan';
import Icon from '@/components/atoms/Icon';
import FollowBtn from '@/components/common/NewFollowBtn';
import AccountModel from '@/models/Account';
import { API } from '@/api/config';

import { sharingMenu } from '@/mixins/sharingMenu';
export default {
  name: 'AccountStatusBarActionsClan',
  components: {
    FollowBtn,
    Icon,
  },
  mixins: [join, sharingMenu],
  data() {
    return {
      isUserBlocked: false,
      model: new AccountModel(),
      statusOfRequest: '',
    };
  },
  computed: {
    ...mapState('current', ['account', 'accountId']),
    ...mapState('my', { myAccount: 'account' }),
  },
  created() {
    this.getIsBlockedAccountInfo();
    this.getClanStatus();
  },
  methods: {
    ...mapMutations(['updateAccountKey']),
    ...mapActions({
      openPopoverMenu: 'popoverMenu/open',
    }),
    ...mapActions([
      'getAccountBlockedBy',
      'blockAccount',
      'closeModal',
      'openModal',
      'errorNotify',
      'fetchClanDetails',
    ]),
    getClanStatus() {
      this.fetchClanDetails(this.$route.params.accountId).then(res => {
        this.statusOfRequest = res.joining_state;
      });
    },
    async getPostAuthorProfile(id) {
      const response = await API(`/clans/${id}`);
      this.model = new AccountModel(
        response.data.type,
        response.data._id
      ).update(response.data);
      this.showFollowButton = true;
    },
    joinAction() {
      this.joinClanAction(this.account).then(() => {
        this.updateAccountKey();
      });
    },
    blockAccountAction() {
      this.blockUserLoading = true;
      this.blockAccount({
        accountType: this.account._type,
        accountId: this.accountId,
      })
        .then(() => {
          this.closeModal();
          this.isUserBlocked = true;
          this.blockUserLoading = false;
          this.$emit('authorBlocked');
        })
        .catch(this.errorNotify);
    },
    getIsBlockedAccountInfo() {
      this.isLoading = true;
      this.getAccountBlockedBy({
        accountType: this.account._type,
        accountId: this.accountId,
      })
        .then(res => {
          res.map(profile => {
            if (profile === this.myAccount.login) this.isUserBlocked = true;
          });
        })
        .catch(this.errorNotify)
        .finally(() => {
          this.isLoading = false;
        });
    },
    openBlockConfirm() {
      return this.openModal({
        name: 'HeraConfirm',
        props: {
          text: this.$t(
            '_web_profile_block_user_request',
            'Are you sure you want to block {name}? All content from this account will be hidden',
            {
              name: this.$filters.displayName(this.account),
            }
          ),
          cancelButtonText: this.$t('_web_post_delete-cancel', 'Cancel'),
          confirmButtonText: this.$t('_web_post_block-confirm', 'Yes, block'),
          isLoading: this.blockUserLoading,
        },
        events: {
          cancel: this.closeModal,
          confirm: this.blockAccountAction,
        },
        options: {
          clickOnBackdrop: false,
          escKey: false,
        },
      });
    },
    setActionPopover(event) {
      const items = [
        {
          label: this.isUserBlocked
            ? this.$t('_web_user-is-blocked', '{name} is blocked', {
                name: this.$filters.displayName(this.account),
              })
            : this.$t('_web_post_block-user', 'Block {name}', {
                name: this.$filters.displayName(this.account),
              }),
          action: this.isUserBlocked ? null : this.openBlockConfirm,
          loading: this.blockUserLoading,
        },
      ];
      this.openPopoverMenu({
        event,
        settings: {
          stopItemClickBubbling: true,
          isFixed: false,
          autoClose: true,
          targetSelector: 'svg',
        },
        items,
      });
    },
  },
};
</script>

<style lang="scss">
.follow-btn-cta {
  justify-content: center;
}
.additional-actions-wrapper {
  @include auto-rtl(right, 0);
}
@media screen and (max-width: 767px) {
  .follow-btn-cta {
    justify-content: start;
  }
}
</style>
